export const ENTITY_TYPE = {
  HUNG_COMP: 'HUNG_COMP',
  HUNG_CORP: 'HUNG_CORP',
  HUNG_PRIV_IND: 'HUNG_PRIV_IND',
  FOREIGN_ENTITY: 'FOREIGN_ENTITY',
  INVESTMENT_ENTITY: 'INVESTMENT_ENTITY',
  STATE_ENTITY: 'STATE_ENTITY',
  UNIVERSITY_ENTITY: 'UNIVERSITY_ENTITY',
  MUNICIPALTIY_ENTITY: 'MUNICIPALTIY_ENTITY', // WARNING: this typo is made at the vendor. DONT FIX IT! just when they have fixed it :D Please notify frontend as well
  UNIDENTIFIED_ENTITY: 'UNIDENTIFIED_ENTITY'
}

export const CLASSIFICATION = {
  Micro: 'Micro',
  Kis: 'Kis',
  Kozep: 'Kozep',
  Nagy: 'Nagy',
  NemTudjukMinositeni: 'NemTudjukMinositeni',
  NemAdhatoKiKkvMinosito: 'NemAdhatoKiKkvMinosito',
  LimitTullepes: 'LimitTulLepes',
  EgyesuletVagyBefekteto: 'EgyesuletVagyBefekteto',
  UjVallalatKizarolag: 'UjVallalatKizarolag',
  UjVallalatTalalhato: 'UjVallalatTalalhato',
  HianyzoBeszamolo: 'HianyzoBeszamolo',
  EgyeduliNagyvallalatTulajdonos: 'EgyeduliNagyvallalatTulajdonos'
}
